"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const path_1 = require("./path");
function get(value, path) {
    // eslint-disable-next-line eqeqeq
    if (path == null)
        return value;
    const parts = (0, path_1.toPathParts)(path);
    if (parts.length === 0)
        return value;
    for (let i = 0; i < parts.length; i++) {
        const isObj = typeof value === 'object' && value !== null;
        if (!isObj)
            break;
        const part = parts[i];
        // eslint-disable-next-line no-param-reassign
        value = value[part];
    }
    return value;
}
exports.default = get;
